import home from "@/views/home/index.vue";
import system from "@/views/system/staff.vue"
import equipmentClassification from "@/views/equipment/equipmentClassification.vue"
import equipmentLedger from "@/views/equipment/equipmentLedger.vue"
import equipmentDataAcquisition from "@/views/equipment/equipmentDataAcquisition.vue"
import equipmentWarehousing from "@/views/equipment/equipmentWarehousing.vue"
import tenantManagement from "@/views/masterData/tenantManagement.vue"
import projectManagement from "@/views/masterData/projectManagement.vue"
import procedureManagement from "@/views/masterData/procedureManagement.vue"
import deviceAlarmType from "@/views/equipment/deviceAlarmType.vue"
import equipmentLedgerEdit from "@/views/equipment/equipmentLedgerEdit.vue"
import tenantdepartment from "@/views/system/tenant_department.vue"
import operationlogs from "@/views/system/operation-logs.vue"
import dictionaryMenu from "@/views/system/dictionaryMenu/index.vue"
import Personnel from '@/views/system/Personnel.vue'
import Menu from '@/views/system/menu.vue'
// import Docx from '@/views/document/docx.vue'
// import Excel from '@/views/document/excel.vue'
// import Pdf from '@/views/document/pdf.vue'
// import Pptx from '@/views/document/pptx.vue'

import { getList } from '@/api/menu.js';
// console.log(11111111111)
let userInfo = localStorage.getItem("user");
if (userInfo) {
    const res = await getList({});
    if (res.code === 200) {
        console.log(res.data)
    }
}

export const constantRoutes = [
    {
        path: "/home",
        name: "首页",
        component: home,
    },
    // {
    //     path: '/document/docx',
    //     name: '文件在线查看',
    //     children: [
    //         {
    //             path: '/document/docx',
    //             name: 'docx文件预览',
    //             component: Docx,
    //         },

    //         {
    //             path: '/document/excel',
    //             name: 'excel文件预览',
    //             component: Excel,
    //         },
    //         {
    //             path: '/document/pdf',
    //             name: 'pdf文件预览',
    //             component: Pdf,
    //         },
    //         {
    //             path: '/document/pptx',
    //             name: 'pptx文件预览',
    //             component: Pptx,
    //         }
    //     ]
    // },
    {
        path: '/equipment/equipmentClassification',
        name: '设备管理',
        children: [
            {
                path: '/equipment/equipmentClassification',
                name: '设备分类',
                component: equipmentClassification,
            },
            {
                path: '/equipment/equipmentLedger',
                name: '设备台账',
                component: equipmentLedger,
            },
            {
                path: '/equipment/deviceAlarmType',
                name: '设备告警分类',
                component: deviceAlarmType,
            },
            {
                path: '/equipment/equipmentDataAcquisition',
                name: '设备数采',
                component: equipmentDataAcquisition,
            },
            {
                path: '/equipment/equipmentLedgerEdit',
                name: '设备台账编辑',
                component: equipmentLedgerEdit,
                hidden: true
            },
        ]

    },
    {
        path: '/masterData/tenantManagement',
        name: '主数据',
        children: [
            {
                path: '/masterData/tenantManagement',
                name: '租户管理',
                component: tenantManagement,
            },
            {
                path: '/masterData/projectManagement',
                name: '项目管理',
                component: projectManagement,
            },
            {
                path: '/masterData/procedureManagement',
                name: '工序管理',
                component: procedureManagement,
            },
        ]

    },
    {
        path: '/system/tenantdepartment',
        name: '系统维护',
        children: [
            {
                path: '/system/tenantdepartment',
                name: '组织架构',
                component: tenantdepartment,
            },
            {
                path: '/system',
                name: '角色管理',
                component: system,
            },
            {
                path: '/system/menu',
                name: '菜单管理',
                component: Menu,
            },
            {
                path: '/system/Personnel',
                name: '人员信息',
                component: Personnel,
            },
            {
                path: '/system/operation-logs',
                name: '登录日志',
                component: operationlogs,
            },
            {
                path: '/system/dictionaryMenu',
                name: '字典菜单',
                component: dictionaryMenu,
            }
        ]
    }
]